import React from 'react';
import { AnimatedSection } from '../../components/ui/AnimatedSection';
import { Button } from '../../components/ui/Button';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FaithDiscipline() {
  return <main className="w-full pt-32 pb-24 bg-dark min-h-screen" data-id="element-673">
      <article className="max-w-3xl mx-auto px-6" data-id="element-674">
        <AnimatedSection data-id="element-675">
          <Link to="/blog" className="inline-flex items-center text-gold hover:text-white transition-colors mb-8 text-sm font-bold uppercase tracking-wider" data-id="element-676">
            <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-677" />
            Back to Insights
          </Link>

          <div className="mb-12" data-id="element-678">
            <span className="text-gold text-xs font-bold uppercase tracking-wider px-3 py-1 border border-gold/30 rounded-full mb-6 inline-block" data-id="element-679">
              Faith
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 font-heading leading-tight" data-id="element-680">
              Faith, Discipline, and Physical Transformation
            </h1>
            <p className="text-xl text-muted leading-relaxed mb-6" data-id="element-681">
              True transformation is not physical first — it starts with
              identity.
            </p>
            <div className="flex items-center text-sm text-muted font-medium border-t border-border pt-6" data-id="element-682">
              <span data-id="element-683">Sep 02, 2025</span>
              <span className="mx-3" data-id="element-684">•</span>
              <span data-id="element-685">5 min read</span>
            </div>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.2} className="prose prose-invert prose-lg max-w-none prose-headings:font-heading prose-headings:text-white prose-a:text-gold hover:prose-a:text-white prose-strong:text-white" data-id="element-686">
          <p data-id="element-687">
            Most people approach health from appearance. But health was never
            meant to be vanity. It was meant to be stewardship.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-688">
            A Different Perspective
          </h3>
          <p data-id="element-689">Your body is something you've been entrusted with.</p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-690">
            Why Discipline Alone Fails
          </h3>
          <p data-id="element-691">
            You can follow a plan, but if your identity doesn't change, results
            won't last.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-692">
            What True Transformation Looks Like
          </h3>
          <p data-id="element-693">When your beliefs shift, your actions follow naturally.</p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-694">
            What This Means for You
          </h3>
          <p data-id="element-695">You don't need more motivation. You need alignment.</p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-696">
            The BioShift Perspective
          </h3>
          <p data-id="element-697">We focus on identity, structure, and long-term transformation.</p>
          <p className="text-xl font-medium text-gold italic mt-8" data-id="element-698">
            Transformation is not about trying harder. It's about becoming
            different.
          </p>
        </AnimatedSection>

        <AnimatedSection delay={0.3} data-id="element-699">
          <div className="mt-16 pt-12 border-t border-border text-center bg-surface p-10 rounded-lg" data-id="element-700">
            <h3 className="text-2xl font-bold text-white mb-4 font-heading" data-id="element-701">
              Ready for true transformation?
            </h3>
            <p className="text-muted mb-8 max-w-lg mx-auto" data-id="element-702">
              Join our Faith & Fitness program to align your physical health
              with your spiritual purpose.
            </p>
            <Button href="https://holistic-health.bioshift.net/calender-booking" size="lg" data-id="element-703">
              Book a Free Health Strategy Call
            </Button>
          </div>
        </AnimatedSection>
      </article>
    </main>;
}